<section class="hero inner-pages">
    <div class="base-fit">
        <img src="/assets/images/about/hero.png">
    </div>
    <div class="text-wrapper">
        <h2>{{'header.Terms and Conditions' | translate}}</h2>
    </div>
</section>

<div class="page-content">
    <section class="card-with-shadow">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card terms-conditions">
                        <div class="card-title">
                            {{'header.Terms and Conditions' | translate}}
                        </div>
                        <div class="hint">
                            {{'terms.Please read these terms and conditions carefully before using Our Service' | translate}}
                        </div>

                        <div class="content">
                            <h3>{{'terms.Terms and Conditions for the User' | translate}}:</h3>
                            <p>
                                {{'terms.Terms and Conditions for the User des' | translate}}
                            </p>

                            <!-- <h3>{{'terms.Discover Thrwty: Insights in our platform' | translate}}:</h3>
                            <p>
                                {{'terms.Discover Thrwty: Insights in our platform desc' | translate}}
                            </p>
                            <p>
                                {{'terms.Discover Thrwty: Insights in our platform desc 2' | translate}}
                            </p> -->
                            <h3>{{'terms.Definitions' | translate}}:</h3>
                            <span>{{'terms.The terms or words below are defined as follows' | translate}}:</span>
                            <ul class="numerical">
                                <li>
                                    <p>{{'terms.The Platform or the Digital Platform: Thrwty platform' | translate}} </p>
                                </li>
                                <li>
                                    <p>{{'terms.The Account: The users account on the Digital platform' | translate}} </p>
                                </li>
                                <li>
                                    <p>{{'terms.The Company: Al Tharwah Al Basharia Limited' | translate}} </p>
                                </li>
                                <li>
                                    <p>{{'terms.The User: Any individual using the Digital platform in accordance with the requirements of these terms and conditions' | translate}} </p>
                                </li>
                            </ul>



                            <h3>{{'terms.Terms of Use for the Platform' | translate}}:</h3>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.Terms of Use for the Platform 1' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.Terms of Use for the Platform 2' | translate}} </p>
                                </li>
                            </ul>


                            <h3>{{'terms.Termination and Access Restriction' | translate}}:</h3>
                            <p>
                                {{'terms.Termination and Access Restriction desc' | translate}}
                            </p>


                            <!-- <h3>{{'terms.Termination' | translate}}</h3>
                            <p>
                                {{'terms.Termination desc 1' | translate}}
                            </p>
                            <p>
                                {{'terms.Termination desc 2' | translate}}
                            </p> -->
                            <h3>{{'terms.User Obligations' | translate}}:</h3>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.User Obligations desc 1' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 2' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 3' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 4' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 5' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 6' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 7' | translate}}</p>
                                </li>
                                <li>
                                    • <p> {{'terms.User Obligations desc 8' | translate}}</p>
                                </li>
                            </ul>

                            <!-- <h3>{{'terms.Amendments to the Terms and Conditions and the Operation Mechanism of the Digital Platform' | translate}}:</h3>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.Amendments to the Terms and Conditions and the Operation Mechanism of the Digital Platform desc 1' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Amendments to the Terms and Conditions and the Operation Mechanism of the Digital Platform desc 2' | translate}}</p>
                                </li>
                            </ul> -->
                            <h3>{{'terms.Intellectual Property Rights' | translate}}:</h3>
                            <p>
                                {{'terms.Intellectual Property Rights desc' | translate}}
                            </p>
                            <h3>{{'terms.Rights of the Digital Platform' | translate}}:</h3>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 1' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 2' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 3' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 4' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 5' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 6' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 7' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Rights of the Digital Platform desc 8' | translate}} </p>
                                </li>
                            </ul>
                            <h3>{{'terms.Harming the Digital Platform' | translate}}:</h3>
                            <p>
                                {{'terms.Harming the Digital Platform desc' | translate}}
                            </p>

                            <h3>{{'terms.General Provisions' | translate}}:</h3>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.General Provisions desc 1' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.General Provisions desc 2' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.General Provisions desc 3' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.General Provisions desc 4' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.General Provisions desc 5' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.General Provisions desc 6' | translate}} </p>
                                </li>
                            </ul>
                            <h3>{{'terms.Contact Information' | translate}}:</h3>
                            <span>{{'terms.For communication with the digital platform, please use the following channels' | translate}}:</span>
                            <ul class="bold-dots">
                                <li>
                                    • <p> {{'terms.Platform Email' | translate}}: info&#64;thrwty.com </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Unified Contact Number' | translate}}: <span style="display: inline-block; direction: ltr;">+9200 19 590</span> </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Submission of Inquiries through the designated form' | translate}} </p>
                                </li>
                                <li>
                                    • <p> {{'terms.Interaction via the digital platforms official social media accounts' | translate}} </p>
                                </li>

                                <span>
                                    {{'terms.Inquery 1' | translate}}
                                    info&#64;thrwty.com. {{'terms.Inquery 2' | translate}}
                                </span>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>